import type { DatavizGrade } from './model/dataviz.types';
import type { HeatmapRange } from './model/heatmap.types';

/**
 * 칸 값 → 등급. null · 0 은 none, 그 밖에는 from ≤ 값 ≤ to 인 첫 구간(ranges 순서). 맞는 구간이 없으면 none.
 * 경계를 어떻게 나눌지(연속 경계 등)는 부르는 쪽이 ranges 로 정한다.
 */
export function heatmapGradeOf(
  value: number | null,
  ranges: readonly HeatmapRange[],
): DatavizGrade {
  if (value === null || value === 0 || !Number.isFinite(value)) return 'none';
  return ranges.find((range) => range.from <= value && value <= range.to)?.grade ?? 'none';
}
